<template>
    <rkm-modal
        persistent
        ref="Modal"
        title="Protocolo de agendamento"
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.opcoesRetiradaProtocoloAgendamento"
                        label="Retirada do protocolo"
                        text-field="nome"
                        v-model="data.model.opcaoRetiradaProtocoloAgendamentoId"
                        value-field="id"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>

                <rkm-col v-if="data.model.opcaoRetiradaProtocoloAgendamentoId === enums.opcaoRetiradaProtocoloAgendamento.RETIRADO">
                    <rkm-form-input
                        :validations="validations.nomePessoaRetiradaProtocoloAgendamento"
                        label="Nome de quem retirou o protocolo"
                        uppercase
                        v-model="data.model.nomePessoaRetiradaProtocoloAgendamento"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <template v-slot:footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleSave"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Vuex.
import { mapGetters } from 'vuex'

// Enums.
import opcaoRetiradaProtocoloAgendamento from '@/enums/regulacao/opcaoRetiradaProtocoloAgendamento'

export default {
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        validations() {

            return {
                nomePessoaRetiradaProtocoloAgendamento: { required: true, max: 150 },
            }
        }
    },
    data: () => ({
        enums: { opcaoRetiradaProtocoloAgendamento },
    }),
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleSave() {

            this.$refs.Form.validate().then(valid => {

                if (!valid) return

                this.$emit('save')
                this.$refs.Modal.hide()
            })
        },
    },
    props: {
        data: { type: Object, required: true },
    }
}
</script>